exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SmartWarning-controls {\n  display: flex;\n  justify-content: flex-end; }\n\n.SmartWarning-button {\n  margin: 20px 10px 0; }\n\n.SmartWarning-text {\n  width: 100%;\n  text-align: center;\n  margin-top: 20px; }\n", ""]);

// exports
